/* src/app/core/pages/login/login.component.scss */
.login-main-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: whitesmoke;
}
.login-main-container .login-left-container {
  flex: 4;
  height: 100%;
}
.login-main-container .login-right-container {
  flex: 2;
  height: 100%;
  min-width: 20rem;
  max-width: 30rem;
}
/*# sourceMappingURL=login.component.css.map */
